"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var styles_1 = require("@mui/material/styles");
var TableRow_1 = __importDefault(require("./TableRow"));
var StyledMuiTableHead = (0, styles_1.styled)(material_1.TableHead)(function (_a) {
    var theme = _a.theme;
    return ({
        padding: theme.spacing(1, 0),
        margin: 0,
        '& p': {
            color: '#B3B3B3',
        },
        borderRadius: "".concat(theme.shape.borderRadius, "px ").concat(theme.shape.borderRadius, "px 0px 0px"),
    });
});
var TableHeader = function (_a) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    return ((0, jsx_runtime_1.jsx)(StyledMuiTableHead, __assign({}, rest, { children: (0, jsx_runtime_1.jsx)(TableRow_1.default, { children: children }) })));
};
exports.default = (TableHeader);
